import 'components/shortlist/actions/save/index.css'
import '../contact-list-change/index.css'
import './index.css'

import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'

import {
  listFormClose,
  listFormPostImportSave,
  listFormSave,
  loadEmailGroups,
} from '@disco/state-management/actions/EmailGroupActions'
import { getFormContacts } from '@disco/state-management/selectors/contacts'

import type { Contact, RecipientListId } from 'types/list'
import type { State } from 'types/redux'

import DocumentHeadTags from 'components/document-head-tags'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'

import SelectList from './select-list'

function mapStateToProps(state: State): any {
  return {
    emailGroups: state.emailGroups,
    listForm: state.forms.listForm,
    contacts: getFormContacts(state),
  }
}

const mapDispatchToProps = {
  listFormPostImportSave,
  listFormSave,
  listFormClose,
  loadEmailGroups,
}

class ImportAddList extends React.Component<
  {
    emailGroups: State['emailGroups']
    listForm: State['forms']['listForm']
    contacts: Array<Contact>
    listFormPostImportSave: typeof listFormPostImportSave
    listFormSave: typeof listFormSave
    listFormClose: typeof listFormClose
    loadEmailGroups: typeof loadEmailGroups
  },
  {
    existingList: string | null | undefined
    newListName: string
  }
> {
  state = {
    existingList: null,
    newListName: '',
  }

  componentDidMount() {
    this.props.loadEmailGroups()
  }

  _name: HTMLInputElement | null | undefined
  _onClose = () => {
    this.props.listFormClose()
  }
  _handleListSelect = (option: any) => {
    this.setState({
      existingList: option,
      newListName: '',
    })
  }
  _handleListNameChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      existingList: null,
      newListName: evt.target.value,
    })
  }
  _handleSubmit = async () => {
    if (this.state.existingList) {
      const listId: RecipientListId = parseInt(this.state.existingList)
      this.props.listFormPostImportSave(listId)
    } else if (this.state.newListName) {
      this.props.listFormSave(this.state.newListName)
    }
  }

  render() {
    const saving = this.props.listForm.saving
    const title = 'Add contacts'
    return (
      <div>
        <DocumentHeadTags title={`${title} | DISCO`} />
        <Modal onRequestClose={this._onClose} isOpen style={modalStyles}>
          <Theme>
            <div className="Form Form_Channel">
              <div className="Form_Header ImportAddList_Header">
                Select an existing mailing list
              </div>
              <SelectList
                value={this.state.existingList}
                onChange={this._handleListSelect}
              />
              <div className="ImportAddList_Or">or</div>
              <div className="Form_Header ImportAddList_Header">
                Create a new mailing list
              </div>
              <input
                onChange={this._handleListNameChange}
                placeholder="Enter list name"
                className="Form_Input ImportAddList_Input"
              />
              {this.props.listForm.error ? (
                <div className="Login_ValidationMessage">
                  {this.props.listForm.error.toString()}
                </div>
              ) : null}
              <ButtonContainer alignRight paddingTop>
                <Button
                  disabled={!this.state.existingList && !this.state.newListName}
                  className="Blue_Button wide-button"
                  progressIndicator={saving}
                  progressCaption="Saving"
                  onClick={this._handleSubmit}
                  caption="OK"
                  appearance="primary"
                />
                <Button onClick={this._onClose} caption="Cancel" />
              </ButtonContainer>
            </div>
          </Theme>
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImportAddList) as any
